/** Viewport slots a feature has filled with a sim that belongs to the pack it was loaded over (Lifetime's sequence, while it's in):
 *  the bridge empties them before it asks for another pack. Otherwise the viewport refits the old pack's sim to the new one, finds
 *  it in another space and unloads it itself with an error event, as Lifetime's Period switch did between the fetal and neonatal
 *  packs (gate 64). The feature adds its slot as it loads the sim, and takes it out after its own unload. */
export const packBoundSlots = new Set<string>();
